import React, { useState, useEffect } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import makeStyles from '@mui/styles/makeStyles';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import BrandButton from 'components/BrandButton';
import './ModalWelcome.scss';

const useStyles = makeStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        width: 600,
        border: '2px solid #000',
        backgroundColor: '#1E3C4D',
        color: 'white',
        padding: '20px',
    },
    closeIcon: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    title: {
        fontWeight: 400,
        paddingTop: '10px',
    },
});

const ModalWelcome = ({ onRedirect }) => {
    const [ isShowing, setIsShowing ] = useState(true);
    const history = useHistory();
    useEffect(() => {
        if (!isShowing) {
            history.push('/accounts/overview');
        }
    }, [ isShowing ]);
    const hideModal = () => {
        setIsShowing(false);
    };
    const classes = useStyles();
    return (
        <Modal
            open={ isShowing }
            className={ `${ classes.modal } fl-modal-browser-tip` }
            onClose={ hideModal }
            disableEnforceFocus
            disableAutoFocus={ true }
            closeAfterTransition
            BackdropComponent={ Backdrop }
            BackdropProps={ {
                timeout: 500,
            } }>
            <Fade in={ isShowing }>
                <div className='fl-modal-info'>
                    <i className='fa fa-times close-icon' onClick={ hideModal } />
                    <div className='fl-modal-title'>
                        <h2>{i18n.t('purchase.Welcome_aboard')}</h2>
                        {i18n.t('purchase.Your_invoice_has_been_sent_via_email')}
                        <BrandButton
                            onClick={ onRedirect }>
                            {i18n.t('purchase.Go_to_Dashboard')}
                        </BrandButton>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
};

ModalWelcome.propTypes = {
    onRedirect: PropTypes.func,
};


export default ModalWelcome;
